import styled from 'styled-components';

import { Box, system, SystemProps } from '@sternum/styled-system';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const VerticalBarStyled = styled(Box)<SystemProps>`
  height: 12px;
  width: 2px;
  border-radius: 100px;
  background-color: ${ct({ Dark: Colors.GreenMiddle, Light: Colors.GreenMiddle })};

  ${system}
`;
